import {
  SliderArrowLeftIcon,
  SliderArrowRightIcon,
} from '@twistopayments/design-system/icons/homepage'
import { hiddenDown, hiddenUp } from '@twistopayments/design-system/styles'
import { isNil } from 'ramda'

import type { HeroSliderCompactComponent } from '@twisto/api-cms'

import { StrapiMedia } from 'homepage/components/atoms'

import { HeroDescription } from '../../hero-description'
import { HeroTitle } from '../../hero-title'

import * as styles from './slider-compact.styles'

type SliderProps = {
  isActive: boolean
  isInner?: boolean
  currentIndex?: number
  totalSlides?: number
  handleNext?: () => void
  handlePrev?: () => void
  imagePriority?: boolean
}

export const SliderCompact = ({
  title,
  highlightedTitle,
  description,
  descriptionHighlighted,
  image,
  isActive,
  isInner = false,
  currentIndex,
  totalSlides,
  handleNext,
  handlePrev,
  imagePriority = false,
}: HeroSliderCompactComponent & SliderProps) => (
  <div
    css={[
      styles.slider,
      isActive ? styles.active : '',
      isInner ? styles.inner : '',
    ]}
  >
    <div css={styles.content}>
      <div css={styles.hero}>
        <div css={[styles.heroImageWrapper, hiddenDown('sm')]}>
          {!isNil(image?.url) && (
            <StrapiMedia priority={imagePriority} {...image} />
          )}
        </div>

        <div css={styles.heroCell}>
          <div css={styles.cellContent}>
            <div css={styles.counter}>
              <h4>
                {/* eslint-disable-next-line react/jsx-no-literals */}
                {currentIndex}/{totalSlides}
              </h4>

              <div css={[styles.controls, hiddenUp('smMd')]}>
                <button onClick={handlePrev}>
                  <SliderArrowLeftIcon />
                </button>
                <button onClick={handleNext}>
                  <SliderArrowRightIcon />
                </button>
              </div>
            </div>
            {title && (
              <HeroTitle
                highlighted={highlightedTitle}
                title={title}
                variant="h3"
              />
            )}

            <div css={[styles.heroImageWrapper, hiddenUp('smMd')]}>
              {!isNil(image?.url) && (
                <StrapiMedia priority={imagePriority} {...image} />
              )}
            </div>

            {description && (
              <HeroDescription
                description={description}
                highlighted={descriptionHighlighted}
              />
            )}

            <div css={[styles.controls, hiddenDown('sm')]}>
              <button onClick={handlePrev}>
                <SliderArrowLeftIcon />
              </button>
              <button onClick={handleNext}>
                <SliderArrowRightIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)
